import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {MatOption} from '@angular/material/core';
import {MatAutocompleteTrigger, MatAutocompleteModule} from '@angular/material/autocomplete';
import {NgClass, NgFor, JsonPipe} from '@angular/common';

// Services
import {RequestMethodsService} from "@services/request/request-methods.service";
import {IsInGeofenceService} from "@services/is-in-geofence/is-in-geofence.service";
import {CityService} from "@services/city/city.service";
import {AuthService} from "@services/auth/auth.service";

// Constants
import {FullAddressLongLatInterface} from "@interfaces/orders/address.interface";
import {EndpointConstant} from "@interfaces/global/endpoint.constant";
import {CityInterface, CityPaginationInterface} from "@interfaces/components/cities.interface";
import {FavoriteAddressInterface} from "@interfaces/orders/favorite-address.interface";
import {SearchLocationTypeEnum} from "@interfaces/components/enums/search-location-type.enum";
import {FiltrationDefaultStateConst} from "@interfaces/catalog/filtration-default-state.const";
import {SearchInStringPipe} from "../../../pipes/string-methods/search-in-string.pipe";


@Component({
  selector: 'app-search-location',
  templateUrl: './search-location.component.html',
  styleUrls: ['./search-location.component.scss'],
  standalone: true,
  imports: [
    NgClass,
    MatAutocompleteTrigger,
    MatAutocompleteModule,
    NgFor,
    MatOption,
    TranslateModule,
    SearchInStringPipe
  ]
})

export class SearchLocationComponent implements OnInit{
  @ViewChild('searchInput') inputSearch!: ElementRef;
  @Input() type: SearchLocationTypeEnum = SearchLocationTypeEnum.FROM_MAP;
  @Input() fullAddress!: string;
  @Input() mobileSearch!: boolean;
  @Input() locations: any;
  @Input() citySearch = false;
  @Output() getLocation = new EventEmitter<{ address: FullAddressLongLatInterface | null } | { city: CityInterface | null } >();
  @Output() searchLocationEmitter = new EventEmitter<string>();
  @Output() closeComponentEmitter = new EventEmitter<void>();

  favoriteAddress!: Array<FavoriteAddressInterface>;
  filteredFavoriteAddressList!: Array<FavoriteAddressInterface>;
  fromSearch = false;
  city!: CityInterface;
  fullAddressObject!: FullAddressLongLatInterface | null;
  searchLocationTypeEnums = SearchLocationTypeEnum;
  filterData = FiltrationDefaultStateConst;
  arrayOfSearchedCity!: Array<CityInterface>;

  constructor(
    private requestService: RequestMethodsService,
    private cityService: CityService,
    private isInGeofenceServices: IsInGeofenceService,
    private authService: AuthService
  ) {
    const city = this.cityService.getCityModelFromLocalStorage();
    if (city && 'city' in city) {
      this.city = city.city;
    }
    if (!this.authService.getUserInfo()) {
      return;
    }
    this.getAllFavoriteAddressList();
  }

  ngOnInit() {
  }


  searchAddressAndMakeLongLat(text: string,type: 'city' | 'address'): void {
    if (!text) {
      this.resetAddressSearch();
      return;
    }
    if (type === 'address') {
      this.filterFavoriteAddressListBySearch(text);
      this.searchLocationEmitter.emit(text);
    } else {
      this.getCities(text)
    }
  }

  filterFavoriteAddressListBySearch(text: string): void {
    if (!this.city) {
      return;
    }
    this.filteredFavoriteAddressList = this.favoriteAddress?.filter((item) => item.fullAddress.includes(text))
  }

  getAllFavoriteAddressList(): void {
    this.requestService.get(`${EndpointConstant.favorite}-${EndpointConstant.addresses}`)
      .subscribe((response: Array<FavoriteAddressInterface>) => {
        this.favoriteAddress = response;
        this.resetAddressSearch();
        this.searchAddressAndMakeLongLat(this.fullAddress,'address')
      })
  }

  resetAddressSearch(): void {
    this.filteredFavoriteAddressList = this.favoriteAddress;
    this.locations = [];
  }

  addressOrCitySelection(data: any,type: 'address' | 'city'): void {
    if (type === "address") {
      const cityName = data.properties._data.metaDataProperty.GeocoderMetaData.Address.Components.find((
        (component: any) => component.kind === 'locality'))
        ?.name || '';
      this.fullAddressObject = this.isInGeofenceServices.fromGeObjectGetLongLatAndAddress(
        data.properties.get('name'), data.geometry._coordinates, cityName
      );
      this.fromSearch = true;
      this.getLocation.emit({address: this.fullAddressObject});
    } else {
      this.getLocation.emit({city: data});
    }
  }


  getCities(searchedValue = ''): void {
    this.requestService.get(`${EndpointConstant.cities}/${EndpointConstant.all}?page=1&size=100&search=${searchedValue}`
    ).subscribe((response: CityPaginationInterface) => {
      this.arrayOfSearchedCity = response.content.filter(item=>item.name);
    }, (error) => console.log(error))
  }

}
